import { IPublishMenuSetRequestBody, IPublishMenuSetResponseBody } from './types';
import { API_URL } from '../constants';
import { postPublishRequest } from '../postPublishRequest/postPublishRequest';

export const publishMenuSet = (
  menuSetId: string,
  payload: IPublishMenuSetRequestBody,
): Promise<IPublishMenuSetResponseBody> =>
  postPublishRequest(
    `${API_URL}/publish/menu-sets/${menuSetId}`,
    payload,
    'Something went wrong whilst publishing the menu set',
  );
